import _toConsumableArray from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.search.js";
import { __decorate } from "tslib";
import path from 'path';
import Fuse from 'fuse.js'; // A lightweight fuzzy-search module
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { PermissionModule } from '@/store/modules/permission';
import i18n from '@/lang'; // Internationalization
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "search", '');
    _defineProperty(_this, "show", false);
    _defineProperty(_this, "options", []);
    _defineProperty(_this, "searchPool", []);
    _defineProperty(_this, "fuse", void 0);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "routes",
    get: function get() {
      return PermissionModule.routes;
    }
  }, {
    key: "lang",
    get: function get() {
      return AppModule.language;
    }
  }, {
    key: "onLangChange",
    value: function onLangChange() {
      this.searchPool = this.generateRoutes(this.routes);
    }
  }, {
    key: "onRoutesChange",
    value: function onRoutesChange() {
      this.searchPool = this.generateRoutes(this.routes);
    }
  }, {
    key: "onSearchPoolChange",
    value: function onSearchPoolChange(value) {
      this.initFuse(value);
    }
  }, {
    key: "onShowChange",
    value: function onShowChange(value) {
      if (value) {
        document.body.addEventListener('click', this.close);
      } else {
        document.body.removeEventListener('click', this.close);
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.searchPool = this.generateRoutes(this.routes);
    }
  }, {
    key: "click",
    value: function click() {
      this.show = !this.show;
      if (this.show) {
        this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.focus();
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.$refs.headerSearchSelect && this.$refs.headerSearchSelect.blur();
      this.options = [];
      this.show = false;
    }
  }, {
    key: "change",
    value: function change(route) {
      var _this2 = this;
      this.$router.push(route.path);
      this.search = '';
      this.options = [];
      this.$nextTick(function () {
        _this2.show = false;
      });
    }
  }, {
    key: "initFuse",
    value: function initFuse(list) {
      this.fuse = new Fuse(list, {
        shouldSort: true,
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [{
          name: 'title',
          weight: 0.7
        }, {
          name: 'path',
          weight: 0.3
        }]
      });
    }
    // Filter out the routes that can be displayed in the sidebar
    // And generate the internationalized title
  }, {
    key: "generateRoutes",
    value: function generateRoutes(routes) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
      var prefixTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var res = [];
      var _iterator = _createForOfIteratorHelper(routes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var router = _step.value;
          // skip hidden router
          if (router.meta && router.meta.hidden) {
            continue;
          }
          var data = {
            path: path.resolve(basePath, router.path),
            meta: {
              title: _toConsumableArray(prefixTitle)
            }
          };
          if (router.meta && router.meta.title) {
            // generate internationalized title
            var i18ntitle = i18n.t("route.".concat(router.meta.title)).toString();
            data.meta.title = [].concat(_toConsumableArray(data.meta.title), [i18ntitle]);
            if (router.redirect !== 'noRedirect') {
              // only push the routes with title
              // special case: need to exclude parent router without redirect
              res.push(data);
            }
          }
          // recursive child routes
          if (router.children) {
            var tempRoutes = this.generateRoutes(router.children, data.path, data.meta.title);
            if (tempRoutes.length >= 1) {
              res = [].concat(_toConsumableArray(res), _toConsumableArray(tempRoutes));
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return res;
    }
  }, {
    key: "querySearch",
    value: function querySearch(query) {
      if (query !== '') {
        if (this.fuse) {
          this.options = this.fuse.search(query);
        }
      } else {
        this.options = [];
      }
    }
  }]);
}(Vue);
__decorate([Watch('lang')], default_1.prototype, "onLangChange", null);
__decorate([Watch('routes')], default_1.prototype, "onRoutesChange", null);
__decorate([Watch('searchPool')], default_1.prototype, "onSearchPoolChange", null);
__decorate([Watch('show')], default_1.prototype, "onShowChange", null);
default_1 = __decorate([Component({
  name: 'HeaderSearch'
})], default_1);
export default default_1;